var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z",
    fill: "#474A57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.776 13.24.034.51-.56-.063a9.42 9.42 0 0 1-5.327-2.415l-.739-.677-.19.5c-.403 1.114-.145 2.29.694 3.082.448.437.347.5-.425.24-.269-.084-.504-.146-.526-.115-.079.073.19 1.02.403 1.395.29.52.884 1.031 1.533 1.333l.548.24-.649.01c-.627 0-.65.01-.582.229.224.677 1.108 1.395 2.093 1.708l.694.218-.604.334a6.713 6.713 0 0 1-3 .77c-.504.01-.918.052-.918.083 0 .105 1.366.688 2.16.917 2.384.677 5.216.385 7.342-.77 1.511-.823 3.022-2.458 3.727-4.041.38-.843.761-2.385.761-3.124 0-.479.034-.541.66-1.114.37-.333.716-.698.784-.802.112-.198.1-.198-.47-.02-.952.312-1.086.27-.616-.198.347-.334.761-.938.761-1.115 0-.03-.168.021-.358.115-.201.104-.65.26-.985.354l-.604.177-.549-.344c-.302-.187-.727-.395-.95-.458-.572-.146-1.445-.125-1.96.042-1.398.468-2.283 1.676-2.182 2.999Z",
    fill: "#fff"
  })));
};
export default SvgTwitter;